import SiteHeader from "@/components/feature/SiteHeader";
import SiteFooter from "@/components/feature/SiteFooter";
import AboutHero from "./components/AboutHero";
import BrandStory from "./components/BrandStory";
import Philosophy from "./components/Philosophy";
import Craftsmanship from "./components/Craftsmanship";
import TeamValues from "./components/TeamValues";
import AboutCTA from "./components/AboutCTA";

export default function AboutPage() {
  return (
    <main className="min-h-screen">
      <SiteHeader />
      <AboutHero />
      <BrandStory />
      <Philosophy />
      <Craftsmanship />
      <TeamValues />
      <AboutCTA />
      <SiteFooter />
    </main>
  );
}
